export const VISUAL_FRAMES = [
  { value: "planechase", label: "Traditional Planechase (oversized)" },
  { value: "portrait", label: "Standard portrait MTG" },
  { value: "creature", label: "Creature-style frame" },
  { value: "land", label: "Land-style frame" },
  { value: "artifact", label: "Artifact-style frame" },
  { value: "enchantment", label: "Enchantment-style frame" },
  { value: "custom", label: "Completely custom frame" },
];

export const PLAYS_AS = [
  { value: "", label: "Regular card" },
  { value: "plane", label: "Plane" },
  { value: "phenomenon", label: "Phenomenon" },
];

export const RIGHTS_TEXT = "I confirm I created these images or have permission from their creators to upload and share them on The Planar Foundry.";

export const frameLabel = (v) => VISUAL_FRAMES.find((f) => f.value === v)?.label || v;

export const planarTypeLine = (kind, subtype) => (kind === "plane" ? `Plane${subtype?.trim() ? ` — ${subtype.trim()}` : ""}` : "Phenomenon");

export const shapeLabel = (w, h) => (w && h ? `${w}×${h} px · ${w > h ? "landscape" : w < h ? "portrait" : "square"} · ratio ${(w / h).toFixed(3)}` : "");
